module.exports = __webpack_public_path__ + "static/media/binance-coin-bnb-logo.162aaf57.png";